import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxBody3Disable extends ITextBoxProps {}

export const TextBoxBody3Disable = ({
  title,
  color = Colors.TEXT_ICON_TERTIARY,
  font = TextBoxTypes.Body3,
  alignment = TextAligning.Left,
  ...rest
}: ITextBoxBody3Disable): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      {...rest}
    />
  )
}
